import React from "react";

import { Toast, ToastList } from "src/common/components/Toast";
import {
	useCloseNotification,
	useNotificationList
} from "src/features/notifications/hooks";
import { Notification } from "src/features/notifications/types";

export const NotificationList: React.FunctionComponent = () => {
	const notifications = useNotificationList();
	return (
		<ToastList>
			{notifications.map(notification => (
				<NotificationListItem key={notification.id} {...notification} />
			))}
		</ToastList>
	);
};

const NotificationListItem: React.FunctionComponent<Notification> = ({
	id,
	...props
}) => {
	const closeNotification = useCloseNotification();
	const onClose = React.useCallback(() => {
		closeNotification(id);
	}, [closeNotification, id]);
	return <Toast {...props} onClose={onClose} />;
};
